import LocationOverviewEmployeesDirectoryRoute from 'garaje/pods/location-overview/employees/directory/route';

export default class EmployeesDirectoryRoute extends LocationOverviewEmployeesDirectoryRoute {
  controllerName = 'location-overview/employees/directory';
  templateName = 'location-overview/employees/directory';
}
